import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["iframe", "loading", "loadedHint"]
  static values = {
    url: String,
    intervalMs: { type: Number, default: 1500 },
    maxTries: { type: Number, default: 120 } // ~3 minutes
  }

  connect() {
    this.showLoading()
    this._tries = 0
    this._timer = null
    this.startPolling()
  }

  loaded() {
    this.hideLoading()
  }

  disconnect() {
    this.stopPolling()
  }

  showLoading() {
    if (this.hasLoadingTarget) this.loadingTarget.classList.remove("hidden")
    if (this.hasLoadedHintTarget) this.loadedHintTarget.classList.add("hidden")
  }

  hideLoading() {
    if (this.hasLoadingTarget) this.loadingTarget.classList.add("hidden")
    if (this.hasLoadedHintTarget) this.loadedHintTarget.classList.remove("hidden")
  }

  startPolling() {
    if (!this.hasUrlValue) return
    if (this._timer) return

    // Websocket updates are ideal but can fail in some environments.
    // Polling keeps the "Generating…" banner in sync with the background job.
    this._timer = window.setInterval(() => this.poll(), this.intervalMsValue)
    this.poll()
  }

  stopPolling() {
    if (this._timer) window.clearInterval(this._timer)
    this._timer = null
  }

  currentStatus() {
    const el = this.element.querySelector("[data-paper-preview-status]")
    return el ? el.getAttribute("data-paper-preview-status") : null
  }

  async poll() {
    const status = this.currentStatus()
    if (status === "completed" || status === "failed") {
      this.stopPolling()
      return
    }

    this._tries += 1
    if (this._tries > this.maxTriesValue) {
      this.stopPolling()
      return
    }

    try {
      const resp = await fetch(this.urlValue, {
        headers: { "Accept": "text/html" },
        credentials: "same-origin"
      })
      if (!resp.ok) return

      const html = await resp.text()
      this.element.innerHTML = html

      const nextStatus = this.currentStatus()
      if (nextStatus === "completed" || nextStatus === "failed") {
        this.stopPolling()
      }
    } catch (_e) {
      // Ignore transient network issues; try again on next tick.
    }
  }
}


